import { Component, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { Brain, FingerprintPatternIcon, LucideAngularModule } from 'lucide-angular';
import { ProjectCardComponent } from '../project-card.component/project-card.component';
import { SkillBadgeComponent } from '../skill-badge.component/skill-badge.component';
import { ProjectsService } from 'src/app/service/projects.service';
import { SkillsService } from 'src/app/service/skills.service';


@Component({
  selector: "app-home",
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    ProjectCardComponent,
    SkillBadgeComponent,
    LucideAngularModule
],
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  readonly BrainIcon = Brain;
  readonly FingerprintPatternIcon = FingerprintPatternIcon;

  projects = signal<any[] | null>(null);
  skills = signal<any[] | null>(null);

  projectsLoading = signal(true);
  skillsLoading = signal(true);

  featuredProjects = signal<any[]>([]);
  aiSkills = signal<any[]>([]);
  devSkills = signal<any[]>([]);
  toolSkills = signal<any[]>([]);
  otherSkills = signal<any[]>([]);

  constructor(private projectsService: ProjectsService, private skillsService: SkillsService) {
    
  }

  ngOnInit(): void {
    this.projectsService.getProjects().subscribe(data => {
      this.projects.set(data);
      this.featuredProjects.set(data?.filter(p => p.isFeatured).slice(0, 3) ?? []);
      this.projectsLoading.set(false);
    });
    
    this.skillsService.getSkills().subscribe(data => {
      this.skills.set(data);
      this.aiSkills.set(data?.filter(s => s.category === 'libs') ?? []);
      this.toolSkills.set(data?.filter(s => s.category == 'tools') ?? []);
      this.devSkills.set(data?.filter(s => s.category == 'frameworks') ?? []);
      this.otherSkills.set(data?.filter(s => s.category !== 'libs' && s.category !== 'tools' && s.category !== 'frameworks') ?? []);
      this.skillsLoading.set(false);
    });
  }
}
